<template>
    <footer class="tw-pb-8 tw-pt-16 tw-text-[#FBF6E8]" style="background-color: #4e1824">
        <div class="tw-mx-auto tw-max-w-7xl tw-px-8">
            <div class="tw-mb-12 tw-grid tw-grid-cols-1 tw-gap-12 md:tw-grid-cols-4">
                <div class="tw-flex tw-flex-col tw-gap-4">
                    <div class="tw-w-fit tw-rounded-2xl tw-bg-[#FBF6E8] tw-p-3">
                        <img
                            src="@/assets/images/logo-marina.jpg"
                            alt="Marina Cakes and Sweets"
                            class="tw-h-24 tw-w-auto tw-object-contain" />
                    </div>
                    <p class="tw-text-sm tw-leading-relaxed tw-text-[#FBF6E8]">A criar memórias doces no coração de Pitões das Júnias. Cada bolo é uma peça única de arte.</p>
                    <div class="tw-mt-2 tw-flex tw-gap-4">
                        <v-btn
                            icon="mdi-instagram"
                            variant="text"
                            color="white"
                            href="https://www.instagram.com/pastelariapitoes/"
                            aria-label="Instagram"
                            density="comfortable"></v-btn>
                        <v-btn
                            icon="mdi-facebook"
                            variant="text"
                            color="white"
                            href="https://www.facebook.com/PadariaaPitoes"
                            aria-label="Facebook"
                            density="comfortable"></v-btn>
                    </div>
                </div>

                <div>
                    <h4 class="tw-font-serif tw-mb-6 tw-text-lg tw-text-[#FBF6E8]">Navegação</h4>
                    <ul class="tw-flex tw-flex-col tw-gap-4 tw-text-sm tw-text-[#FBF6E8]/85">
                        <li>
                            <router-link
                                :to="{ name: 'About' }"
                                class="hover:tw-text-white"
                                >Sobre</router-link
                            >
                        </li>
                        <li>
                            <router-link
                                :to="{ name: 'Pitões' }"
                                class="hover:tw-text-white"
                                >Pitões</router-link
                            >
                        </li>
                        <li>
                            <router-link
                                :to="{ name: 'Portfolio' }"
                                class="hover:tw-text-white"
                                >Portefólio</router-link
                            >
                        </li>
                        <li>
                            <router-link
                                :to="{ name: 'Sabores' }"
                                class="hover:tw-text-white"
                                >Sabores</router-link
                            >
                        </li>
                        <li>
                            <router-link
                                :to="{ name: 'Categories' }"
                                class="hover:tw-text-white"
                                >Categorias</router-link
                            >
                        </li>
                        <li>
                            <router-link
                                :to="{ name: 'Order' }"
                                class="hover:tw-text-white"
                                >Encomendar</router-link
                            >
                        </li>
                    </ul>
                </div>

                <div>
                    <h4 class="tw-font-serif tw-mb-6 tw-text-lg tw-text-[#FBF6E8]">Contactos</h4>
                    <div class="tw-flex tw-items-center tw-gap-2 tw-font-medium tw-text-[#FBF6E8]">
                        <v-icon
                            size="small"
                            color="white"
                            >mdi-phone</v-icon
                        >
                        <span>276 563 103</span>
                    </div>
                </div>

                <div>
                    <h4 class="tw-font-serif tw-mb-6 tw-text-lg tw-text-[#FBF6E8]">Onde Estamos</h4>
                    <p class="tw-text-sm tw-text-[#FBF6E8]/85">
                        Rua do Outeiro, nº 24<br />
                        5470-370 Pitões das Júnias<br />
                        <span class="tw-text-xs tw-italic tw-text-secondary">(Padaria Pitões)</span>
                    </p>
                </div>
            </div>

            <div class="tw-border-t tw-border-[#FBF6E8]/20 tw-pt-8 tw-text-center tw-text-xs tw-text-[#FBF6E8]/70">
                <p>&copy; {{ new Date().getFullYear() }} Atelier da Marina. Todos os direitos reservados.</p>
                <p class="tw-mt-2">Desenvolvido com carinho para Pitões.</p>
            </div>
        </div>
    </footer>
</template>
